import Vue from 'vue'
import Vuex from 'vuex'
import packageJson from '../../package.json';
import { surveys as surveysDb, answers as answersDb } from '@/database'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    version: packageJson.version || '0',
    count: 0,
    surveys: []
  },

  mutations: {
    setSurveys(state, surveys) {
        state.surveys = surveys;
    },
    setCount(state) {
      state.count++;
    }
  },

  actions: {
    buildSurveys(context) {
      let surveys = [];

      /*
      async function init () {
        const keys = await surveysDb.keys();
        for ( const key in keys ) {
          const item = await surveysDb.getItem(keys[key]);
          surveys.push({
            id: item.id,
            name: item.name,
            total: 0
          })
        }
        const aKeys = await answersDb.keys();
        for ( const aKey in aKeys ) {
          const aItem = await answersDb.getItem(aKeys[aKey]);
          const index = surveys.findIndex(s => s.id == aItem.survey);
          if ( index >= 0 ) {
            surveys[index].total++;
          }
        }
        return surveys;
      }
      init().then(response => {
        context.commit('setSurveys', response)
      });
      */

      surveysDb.keys().then(keys => {
        for ( const key in keys ) {
          surveysDb.getItem(keys[key]).then(value => {
            surveys.push({
              id: value.id,
              name: value.name,
              total: 0
            })
          })
        }
      })
      answersDb.keys().then(keys => {
        for ( const key in keys ) {
          answersDb.getItem(keys[key]).then(value => {
            const { survey } = value.pop();
            const index = surveys.findIndex(s => s.id == survey);
            if ( index >= 0 ){
              surveys[index].total++;
            }
          })
        }
      })
      context.commit('setSurveys', surveys)
    }
  }
})

export default store;